/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as VideoDefs from './defs.defs.js'

const $nsid = 'app.bsky.video.getJobStatus'

export { $nsid }

/** Get status details for a video processing job. */
const main = l.query(
  $nsid,
  l.params({ jobId: l.string() }),
  l.jsonPayload({
    jobStatus: l.ref<VideoDefs.JobStatus>((() => VideoDefs.jobStatus) as any),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
